import regionSettingsMessages from
  'ringcentral-integration/modules/RegionSettings/regionSettingsMessages';

export default {
  region: 'Región',
  [regionSettingsMessages.saveSuccess]: 'La configuración se guardó correctamente.',
  [regionSettingsMessages.dialingPlansChanged]: `Su cuenta ya no es compatible con la región anterior.
    Compruebe su nueva {regionSettingsLink}.`,
  regionSettings: 'configuración de región',
  [regionSettingsMessages.areaCodeInvalid]: 'Introduzca un código de área válido.',
};
